import keyMirror from 'keymirror'

export default keyMirror({
  INPUT: null,
  SENDING: null,
  SENT: null,
  ERROR: null,
})
